import React from "react";

import { useHistory, useParams } from "react-router-dom";
import { Trans, useTranslation } from "react-i18next";

import { useDeviceHook } from "../../utils/hooks/useDeviceHook";
import {
  BabyPeekIntroWrapper,
  BabyPeekIntroBodyWrapper,
  BabyPeekIntroTitle,
  BabyPeekIntroDescription,
  BabyPeekIntroInfoBarWrapper,
  BabyPeekIntroInfoBarBig,
  BabyPeekIntroInfoBarDescription,
  BabyPeekIntroCTAWrapper,
  BabyPeekCTATitle,
  BabyPeekFAQTitle,
  BabyPeekIntroFAQAccordionWrapper,
  BabyPeekDisclaimer,
  BabyPeekDisclaimerTitle,
  BabyPeekDisclaimerGrid,
  BabyPeekDisclaimerText,
  BabyPeekIntroGrid,
  BabyPeekIntroInfoBarWrapperNew,
  BabyPeekIntroMarqueeWrapper,
  BabyPeekRatingsWrapper,
  BabyPeekIntroInfoBarBigMobile,
  BabyPeekIntroInfoBarDescriptionMobile,
  BabyPeekIntroMessageWrapper,
} from "./BabyPeekIntro.styles";

import Decorations from "./BabyPeekIcons/Decorations.png";

import { BabyPeekButton } from "./BabyPeekButton";
import {
  BabyPeekAccordions,
  babyPeekGameAccordion,
  getBabyPeekFAQAccordion,
} from "./BabyPeekAccordion";
import {
  BabyPeekPaymentGradientContentSpecialGrid,
  BabyPeekPaymentGradientTitle,
  BabyPeekPaymentGradientTitleStrikeThrough,
  BabyPeekPaymentPromotionGradient,
  BabyPeekPaymentPromotionGradientContent,
  BabyPeekPaymentPromotionalPriceGrid,
  BabyPeekPaymentSummaryDescription,
  BabyPeekPaymentSummaryItemGrid,
  BabyPeekPaymentSummaryItemGridRow,
  BabyPeekPaymentSummaryTitleTrait,
  BabyPeekPreTestMessage,
} from "./BabyPeekStripe.styles";
import { DetailedResultsBabyPeekText } from "../DetailedResults/DetailedResults.styles";
import { EyeCTA } from "./BabyPeekIcons/EyeCTA";
import { WaveCTA } from "./BabyPeekIcons/WaveCTA";
import { TasteCTA } from "./BabyPeekIcons/TasteCTA";
import { TeethCTA } from "./BabyPeekIcons/TeethCTA";
import {
  BabyPeekButtonNames,
  BabyPeekTraitResponse,
  getUnlockButtonText,
} from "./Services/BabyPeekService";
import { getCentsToDollars } from "../UpfrontPayment/Services/UpfrontPaymentService";
import { BabyPeekIcon } from "./BabyPeekIcons/BabyPeekIcon";
import { BABYPEEK_URL } from "../../utils/urlConstants";
import { TraitMarquee } from "./TraitMarquee";
import BabyPeekVideoEmbed from "../shared/Video/BabyPeekVideoEmbed";
import { TraitSummaryList } from "./BabyPeekIcons/TraitSummaryList";
import { TechnologyGene } from "./BabyPeekIcons/TechnologyGene";
import { FutureFoodie } from "./BabyPeekIcons/FutureFoodie";
import { BabyPeekRatings } from "./BabyPeekIcons/BabyPeekRatings";
import { BabyPeekRatingsStar } from "./BabyPeekIcons/BabyPeekRatingsStar";
import { BabyPeekGamesExclusive } from "./BabyPeekIcons/BabyPeekGamesExclusive";
import { BabyPeekGamesExplosions } from "./BabyPeekIcons/BabyPeekGamesExplosions";
import { BabyPeekChangeIcon } from "./BabyPeekIcons/BabyPeekChangeIcon";
import BabyPeekMultipleReqHeader from "./BabyPeekMultipleReqHeader";

export const BabyPeekIntro: React.FC<{
  babyPeekReport: BabyPeekTraitResponse;
  babyPeekPKVal?: string;
  setLastButtonClick?: React.Dispatch<
    React.SetStateAction<BabyPeekButtonNames | undefined>
  >;
}> = ({ babyPeekReport, babyPeekPKVal, setLastButtonClick }) => {
  const { t } = useTranslation();
  const { deviceType } = useDeviceHook();
  const history = useHistory();

  let { babypeekPK } = useParams<{
    babypeekPK: string;
  }>();
  babypeekPK = babypeekPK ?? babyPeekPKVal;

  return (
    <>
      <div
        style={{
          display: "grid",
          background:
            "linear-gradient(180deg, #FFF6CF 0%, rgba(255, 253, 244, 0.60) 5%, #FFFDF4 100%, #FFFDF4 100%), #FFF",
        }}
      >
        <BabyPeekIntroWrapper>
          <BabyPeekMultipleReqHeader />
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "auto",
              padding: "64px 64px",
              gap: "16px",
            }}
          >
            <BabyPeekIntroGrid>
              <div
                style={{
                  display: "grid",
                  alignItems: "center",
                  justifySelf: "center",
                }}
              >
                <BabyPeekIcon />
                <BabyPeekRatingsWrapper
                  onClick={() => {
                    const anchorEl = document.getElementById("babypeekRatings");
                    if (anchorEl) {
                      anchorEl.scrollIntoView();
                    }
                  }}
                >
                  <BabyPeekRatings />
                </BabyPeekRatingsWrapper>
              </div>
              <BabyPeekIntroTitle deviceType={deviceType}>
                {t("babyPeek.intro.title")}
              </BabyPeekIntroTitle>
              <BabyPeekIntroDescription deviceType={deviceType}>
                {babyPeekReport.experiment_details.landing_page === "a" ? (
                  <Trans
                    i18nKey="babyPeek.intro.descriptionA"
                    components={{ sup: <sup /> }}
                  />
                ) : (
                  <Trans
                    i18nKey="babyPeek.intro.descriptionB"
                    components={{ sup: <sup /> }}
                  />
                )}
              </BabyPeekIntroDescription>
              <div style={{ display: "grid", gridGap: "12px" }}>
                <>
                  {babyPeekReport?.reveal_status === "pending" && (
                    <>
                      <BabyPeekButton
                        variant="filled"
                        id="vwo-unlock-babypeek"
                        style={{
                          width: "300px",
                          height: "44px",
                          justifySelf: "center",
                        }}
                        content={<>{t("babyPeek.buttons.unlockBabyPeek")}</>}
                        onClick={() => {
                          if (setLastButtonClick) {
                            setLastButtonClick("IntroMainUnlock");
                          }
                          history.push(
                            `${BABYPEEK_URL}/${babypeekPK}/checkout`,
                          );
                        }}
                      />
                    </>
                  )}
                </>
              </div>
            </BabyPeekIntroGrid>
          </div>
        </BabyPeekIntroWrapper>
        <BabyPeekIntroBodyWrapper>
          <BabyPeekIntroMarqueeWrapper style={{ padding: "0px 64px" }}>
            <TraitMarquee />
          </BabyPeekIntroMarqueeWrapper>

          <BabyPeekIntroInfoBarWrapper deviceType={deviceType}>
            <div>
              <BabyPeekIntroInfoBarBig>
                {t("babyPeek.traits.labels.eyeColor")}
              </BabyPeekIntroInfoBarBig>
              <BabyPeekIntroInfoBarBig>
                {t("babyPeek.traits.labels.hairColor")}
              </BabyPeekIntroInfoBarBig>
              <BabyPeekIntroInfoBarBig style={{ marginBottom: "48px" }}>
                {t("babyPeek.traits.labels.hairTexture")}
              </BabyPeekIntroInfoBarBig>
              <BabyPeekIntroInfoBarDescription>
                {t("babyPeek.intro.probabilityDescription")}
              </BabyPeekIntroInfoBarDescription>
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                marginBottom: "-32px",
              }}
            >
              <TraitSummaryList />
            </div>
          </BabyPeekIntroInfoBarWrapper>
          {babyPeekReport.unlock_type === "discount_payment" && (
            <BabyPeekPaymentPromotionGradient deviceType={deviceType}>
              <BabyPeekPaymentPromotionGradientContent>
                <BabyPeekPaymentGradientContentSpecialGrid>
                  <BabyPeekPaymentGradientTitle>
                    <BabyPeekIntroInfoBarBig>
                      {t("babyPeek.intro.reports")}
                    </BabyPeekIntroInfoBarBig>
                    <BabyPeekPaymentPromotionalPriceGrid>
                      <DetailedResultsBabyPeekText>
                        {getCentsToDollars(
                          babyPeekReport.bill_details.balance,
                          false,
                        )}
                      </DetailedResultsBabyPeekText>
                      <BabyPeekPaymentGradientTitleStrikeThrough>
                        {getCentsToDollars(24900, true)}
                      </BabyPeekPaymentGradientTitleStrikeThrough>
                    </BabyPeekPaymentPromotionalPriceGrid>
                  </BabyPeekPaymentGradientTitle>

                  <BabyPeekPaymentGradientTitle>
                    <BabyPeekPaymentSummaryItemGrid>
                      <div>
                        <WaveCTA />
                      </div>
                      <BabyPeekPaymentSummaryItemGridRow>
                        <BabyPeekPaymentSummaryTitleTrait
                          deviceType={deviceType}
                        >
                          {t("babyPeek.traits.groups.hair")}
                        </BabyPeekPaymentSummaryTitleTrait>
                        <BabyPeekPaymentSummaryDescription
                          deviceType={deviceType}
                        >
                          {t("babyPeek.intro.summary.hair")}
                        </BabyPeekPaymentSummaryDescription>
                      </BabyPeekPaymentSummaryItemGridRow>
                    </BabyPeekPaymentSummaryItemGrid>
                    <BabyPeekPaymentSummaryItemGrid>
                      <div>
                        <EyeCTA />
                      </div>
                      <BabyPeekPaymentSummaryItemGridRow>
                        <BabyPeekPaymentSummaryTitleTrait
                          deviceType={deviceType}
                        >
                          {t("babyPeek.traits.labels.eyeColor")}
                        </BabyPeekPaymentSummaryTitleTrait>
                        <BabyPeekPaymentSummaryDescription
                          deviceType={deviceType}
                        >
                          {t("babyPeek.traits.labels.eyeColor")}
                        </BabyPeekPaymentSummaryDescription>
                      </BabyPeekPaymentSummaryItemGridRow>
                    </BabyPeekPaymentSummaryItemGrid>
                  </BabyPeekPaymentGradientTitle>
                  <BabyPeekPaymentGradientTitle>
                    <BabyPeekPaymentSummaryItemGrid>
                      <div>
                        <TeethCTA />
                      </div>

                      <BabyPeekPaymentSummaryItemGridRow>
                        <BabyPeekPaymentSummaryTitleTrait
                          deviceType={deviceType}
                        >
                          {t("babyPeek.traits.groups.otherTraits")}
                        </BabyPeekPaymentSummaryTitleTrait>
                        <BabyPeekPaymentSummaryDescription
                          deviceType={deviceType}
                        >
                          {t("babyPeek.intro.summary.otherTraits")}
                        </BabyPeekPaymentSummaryDescription>
                      </BabyPeekPaymentSummaryItemGridRow>
                    </BabyPeekPaymentSummaryItemGrid>
                    <BabyPeekPaymentSummaryItemGrid>
                      <div>
                        <TasteCTA />
                      </div>
                      <BabyPeekPaymentSummaryItemGridRow>
                        <BabyPeekPaymentSummaryTitleTrait
                          deviceType={deviceType}
                        >
                          {t("babyPeek.traits.groups.taste")}
                        </BabyPeekPaymentSummaryTitleTrait>
                        <BabyPeekPaymentSummaryDescription
                          deviceType={deviceType}
                        >
                          {t("babyPeek.intro.summary.taste")}
                        </BabyPeekPaymentSummaryDescription>
                      </BabyPeekPaymentSummaryItemGridRow>
                    </BabyPeekPaymentSummaryItemGrid>
                  </BabyPeekPaymentGradientTitle>
                </BabyPeekPaymentGradientContentSpecialGrid>
                {babyPeekReport?.reveal_status !== "prepaid" && (
                  <div style={{ display: "block" }}>
                    <BabyPeekButton
                      id="vwo-unlock-babypeek"
                      variant="outline"
                      content={<>{getUnlockButtonText()}</>}
                      onClick={() => {
                        if (setLastButtonClick) {
                          setLastButtonClick("PromoUnlock");
                        }
                        history.push(`${BABYPEEK_URL}/${babypeekPK}/checkout`);
                      }}
                    />
                  </div>
                )}
              </BabyPeekPaymentPromotionGradientContent>
            </BabyPeekPaymentPromotionGradient>
          )}
          <BabyPeekIntroInfoBarWrapper deviceType={deviceType}>
            <div style={{ display: "flex", justifyContent: "center" }}>
              <FutureFoodie />
            </div>
            <div>
              <BabyPeekIntroInfoBarBig>
                {t("babyPeek.intro.futureFoodie.title")}
              </BabyPeekIntroInfoBarBig>

              <BabyPeekIntroInfoBarDescription>
                {t("babyPeek.intro.futureFoodie.description")}
              </BabyPeekIntroInfoBarDescription>
            </div>
          </BabyPeekIntroInfoBarWrapper>
          <BabyPeekIntroInfoBarWrapper deviceType="mobile">
            <div>
              <div style={{ marginTop: "-32px", marginBottom: "-195px" }}>
                <BabyPeekGamesExplosions />
              </div>
              <BabyPeekGamesExclusive />
              <BabyPeekIntroInfoBarBigMobile style={{ marginBottom: "24px" }}>
                {t("babyPeek.games.title")}
              </BabyPeekIntroInfoBarBigMobile>
              <BabyPeekIntroInfoBarDescriptionMobile>
                {t("babyPeek.games.unlockDescription")}
              </BabyPeekIntroInfoBarDescriptionMobile>
              <div style={{ display: "grid", marginTop: "10px" }}>
                <BabyPeekAccordions
                  data={babyPeekGameAccordion(babypeekPK, "auth?.access_token")}
                />
              </div>
            </div>
          </BabyPeekIntroInfoBarWrapper>

          <BabyPeekIntroInfoBarWrapperNew
            style={{ position: "relative", justifyContent: "center" }}
            id="babypeekRatings"
          >
            <img
              src={Decorations}
              alt="Decorations"
              style={{ position: "absolute", top: "10px", right: "20px" }}
            />
            <img
              src={Decorations}
              alt="Decorations"
              style={{ position: "absolute", bottom: "10px", left: "20px" }}
            />
            <div style={{ display: "grid", justifyContent: "center" }}>
              <BabyPeekRatingsStar />
            </div>
            <div style={{ display: "grid", justifyItems: "center" }}>
              <BabyPeekVideoEmbed babypeekPK={babypeekPK} />
              <BabyPeekPreTestMessage>
                {t("babyPeek.intro.videoCaption")}
              </BabyPeekPreTestMessage>
            </div>
          </BabyPeekIntroInfoBarWrapperNew>

          <BabyPeekIntroCTAWrapper deviceType={deviceType}>
            <BabyPeekCTATitle deviceType={deviceType}>
              {t("babyPeek.intro.technologyTitle")}
            </BabyPeekCTATitle>
            <TechnologyGene />
            <BabyPeekIntroInfoBarDescription>
              {t("babyPeek.intro.technologyDescription")}
            </BabyPeekIntroInfoBarDescription>
          </BabyPeekIntroCTAWrapper>
          <BabyPeekIntroFAQAccordionWrapper deviceType={deviceType}>
            <BabyPeekFAQTitle deviceType={deviceType}>
              {t("babyPeek.faq.title")}
            </BabyPeekFAQTitle>
            <BabyPeekAccordions data={getBabyPeekFAQAccordion()} />
          </BabyPeekIntroFAQAccordionWrapper>
          <BabyPeekDisclaimer
            style={{
              display: "grid",
              backgroundColor: "#fff",
              backgroundSize: "100% 100%",
            }}
          >
            <BabyPeekDisclaimerTitle>
              {t("babyPeek.disclaimer.title")}
            </BabyPeekDisclaimerTitle>
            <BabyPeekDisclaimerGrid deviceType={deviceType}>
              <ul>
                <li>
                  <BabyPeekDisclaimerText>
                    {t("babyPeek.disclaimer.funOnly")}
                  </BabyPeekDisclaimerText>
                </li>
                <li>
                  <BabyPeekDisclaimerText>
                    {t("babyPeek.disclaimer.resultsMayVary")}
                  </BabyPeekDisclaimerText>
                </li>
              </ul>

              <ul>
                <li>
                  <BabyPeekDisclaimerText>
                    {t("babyPeek.disclaimer.doctorNotOrdered")}
                  </BabyPeekDisclaimerText>
                </li>
                <li>
                  <BabyPeekDisclaimerText>
                    {t("babyPeek.disclaimer.contactBillionToOne")}
                  </BabyPeekDisclaimerText>
                </li>
              </ul>
            </BabyPeekDisclaimerGrid>
          </BabyPeekDisclaimer>
        </BabyPeekIntroBodyWrapper>
      </div>
    </>
  );
};
